/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import UIFormControl from 'UIComponents/form/UIFormControl';
import LanguageSelect from '../LanguageSelect';
import { selectArticle } from '../../selectors/edit';
import { selectScopes } from '../../selectors/scopes';
import { selectAllLanguages } from '../../knowledge-base/selectors/knowledgeBaseDetails';
import { getLanguageNameFromCode } from '../../utils/langUtils';
import { updateArticle } from '../../actions/article/UpdateArticleActions';
import { useAppDispatch, useAppSelector } from '../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function EditArticleLanguageModal(props) {
  const dispatch = useAppDispatch();
  const article = useAppSelector(selectArticle);
  const languages = useAppSelector(selectAllLanguages);
  const scopes = useAppSelector(selectScopes);
  const kbLanguages = [languages.primaryLanguage, ...(languages.additionalLanguages || [])];
  const articleLanguage = article.values.hs_language;
  const [selectedLanguage, setSelectedLanguage] = useState(articleLanguage);
  const onSaveChangesClick = () => {
    dispatch(updateArticle(article, {
      values: {
        hs_language: selectedLanguage
      }
    }));
    props.onClose();
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.edit.editLanguageModal.header"
        })
      })
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "knowledgeContentUI.edit.editLanguageModal.articleCurrentLanguage",
          options: {
            currentLanguage: getLanguageNameFromCode(articleLanguage)
          }
        })
      }), /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.edit.editLanguageModal.languageField.label"
        }),
        children: /*#__PURE__*/_jsx(LanguageSelect
        // @ts-expect-error ts-migrate(2554)
        , {
          disabledLanguages: Object.keys(article.translations),
          knowledgeScopes: scopes,
          onChange: e => setSelectedLanguage(e.target.value),
          validLanguages: kbLanguages,
          value: selectedLanguage
        })
      })]
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        disabled: selectedLanguage === articleLanguage,
        onClick: onSaveChangesClick,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.edit.editLanguageModal.saveChangesButton"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: props.onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.edit.editLanguageModal.cancelButton"
        })
      })]
    })]
  });
}